<template>
  <!-- 403 无权限访问 -->
  <div class="app-container">
    <div class="forbidden-box">
      <div class="forbidden-code">
        <span class="num">4</span>
        <span class="num zero">0</span>
        <span class="num">3</span>
      </div>
      <div class="forbidden-tip">抱歉，您没有访问该页面的权限</div>
      <div class="forbidden-sub">请联系管理员开通权限，或返回首页继续操作</div>
      <div class="forbidden-btns">
        <el-button type="primary" size="small" @click="goHome">返回首页</el-button>
        <el-button size="small" @click="reLogin">重新登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'NoPermission',
  methods: {
    goHome () {
      this.$router.push(store.getIp() || '/')
    },
    reLogin () {
      store.delUser()
      localStorage.clear()
      sessionStorage.clear()
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped lang='less'>
.forbidden-box {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.forbidden-code {
  .num {
    font-size: 96px;
    font-weight: 700;
    color: #409eff;
    letter-spacing: 8px;
    &.zero {
      color: #dcdfe6;
    }
  }
}
.forbidden-tip {
  margin-top: 12px;
  font-size: 20px;
  color: #303133;
  font-weight: bold;
}
.forbidden-sub {
  margin-top: 10px;
  font-size: 14px;
  color: #909399;
}
.forbidden-btns {
  margin-top: 28px;
}
</style>
